import { createReducer } from '@cbgms/base/utils/redux'
import { combineReducers } from 'redux'
import * as types from './types'
import { getOptions } from './selectors'
import { Locales } from '@carsys/enums/locales'
import { UserStatus } from '@cbgms/api/modules/enums'
import { IEmployeeUser, ISupportEmployee } from '@cbgms/api'
import { DropdownItemProps } from 'semantic-ui-react'

const defaultDetailsState = {} as any as ISupportEmployee

type EmployeeSkillsReducerState = Pick<DropdownItemProps, 'key' | 'text' | 'value'>[]
const defaultSkillsState: EmployeeSkillsReducerState = []

type EmployeeStatusReducerState = Readonly<IEmployeeUser>
const defaultStatusState: EmployeeStatusReducerState = {
  Username: '',
  Status: UserStatus.Unknown,
  CreatedAt: '',
  UpdatedAt: '',
  Enabled: false,
  Name: '',
  NamePrefix: '',
  FirstName: '',
  EmailAddress: '',
  Locale: Locales.nl_NL
}

const details = createReducer(defaultDetailsState, {
  [types.LOAD_EMPLOYEE_SUCCESS](_, { payload }) {
    return payload.data.Data
  }
})

const skills = createReducer(defaultSkillsState, {
  [types.LOAD_EMPLOYEE_SKILLS_SUCCESS](_, { payload }) {
    return getOptions(payload.data)
  }
})

const status = createReducer(defaultStatusState, {
  [types.LOAD_EMPLOYEE_STATUS_SUCCESS]: (_, { payload }) => payload.data.Data,
  [types.LOAD_EMPLOYEE_STATUS_FAILED]: () => defaultStatusState
})

const employee = combineReducers({
  details,
  skills,
  status
})

export default employee
